import { Required } from '@/utils/validatorClass'
import { isObject } from '@/utils/validator'
import { remove } from '@/utils/lodash'
import BSelectGraduationSchool from '@/components/BusinessComponents/BSelectGraduationSchool'
import CDate from '../components/CDate'
import CSelect from '../components/CSelect'
import CInput from '../components/CInput'
import CSpan from '../components/CSpan'
import CFileUpload from '../components/CFileUpload'
import CSmartTreeSelectByPopup from '../components/CSmartTreeSelectByPopup'
import CMultiSelectPopup from '../components/CMultiSelectPopup'

// import { Field } from 'vant'

const DEFAULT_PREFIX = '请输入'
const PREFIX = [
  {
    value: [
      CSelect,
      CDate,
      BSelectGraduationSchool,
      CSmartTreeSelectByPopup,
    ],
    label: '请选择',
  },
  {
    value: [CInput],
    label: DEFAULT_PREFIX,
  },
]

export function mixinMethod (Ctor, key, fn) {
  if (Ctor) {
    Ctor.prototype[key] = fn
  }
}

export class Base {
  /**
   * 请参考vue createElement函数第一个参数的组件选项。
   *
   * @type {(string/object/function)}
   * @see [createElement]{@link https://cn.vuejs.org/v2/guide/render-function.html#createElement-%E5%8F%82%E6%95%B0}
   */
  component = 'div'
}
export function normalizeOptions (options) {
  if (!options) {
    return {}
  }

  if (typeof options === 'string') {
    options = { mode: options }
  }

  options.name = options.name || options.value

  // options.mode = options.mode || 'modify'

  return options
}

export function getPrefix (component) {
  for (let index = 0; index < PREFIX.length; index++) {
    const { value, label } = PREFIX[index]

    if (value.includes(component)) {
      return label
    }
  }

  return DEFAULT_PREFIX
}

function normalize () {
  /**
   * 设置一些默认值
   */
  if (!this.rules) {
    this.rules = []
  } else if (isObject(this.rules)) {
    this.rules = [this.rules]
  }

  this.name = this.name || this.value

  /**
   * 自动根据prefixText和组件类型，拼接placeholder。
   */
  if (this.placeholder === undefined && this.label) {
    const label = getPrefix(this.component)
    this.placeholder = `${label}`
  }

  /**
   * 处理used字段
   */
  if (this.used !== undefined) {
    if (!this.params) {
      this.params = {}
    }

    if (this.used) {
      this.params.used = 1
    } else {
      this.params.used = 0
    }
  }

  /**
   * 处理required字段
   */

  if (typeof this.required !== 'undefined') {
    if (!this.rules) {
      this.rules = []
    } else if (!Array.isArray(this.rules)) {
      this.rules = [this.rules]
    }

    const msg = typeof this.required === 'boolean' ? this.label : this.required

    if (this.required) {
      if (!this.rules.find(({ required }) => required)) {
        this.rules.push(new Required(msg))
      }
    } else {
      remove(this.rules, ({ required }) => required)
    }
  }

  /**
   * 处理mode字段
   */
  // if (this.mode === 'view') {
  //   this.component = 'CSpan'
  //   this.rules = []
  // }
}

mixinMethod(Base, 'mergeOptions', mergeOptions)
mixinMethod(Base, 'normalize', normalize)

export function mergeOptions (options) {
  // 处理options
  options = normalizeOptions(options)

  // 合并
  Object.assign(this, options)

  // 处理this
  this.normalize()
}

export class Select extends Base {
  component = CSelect

  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}
export class MultiSelectPopup extends Base {
  component = CMultiSelectPopup
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}
export class SmartTreeSelectByPopup extends Base {
  component = CSmartTreeSelectByPopup

  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

export class Input extends Base {
  component = CInput

  constructor (options) {
    super()

    this.mergeOptions(options)
  }
}
export class DatePicker extends Base {
  component = CDate

  constructor (options) {
    super()

    this.mergeOptions(options)
  }
}

export class Textarea extends Input {
  type = 'textarea'
  autosize = true
  prefixPosition = 'top'
  rows = 3
  showWordLimit = true

  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}
export class InputNumber extends Input {
  type = 'number'

  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}
export class MultipleSelect extends Select {
  currentPage=false
  multi = true

  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

export class Span extends Base {
  component = CSpan
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

export class Upload extends Base {
  component = CFileUpload
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

export class Cascader extends Select {
  remote = true
  tree = true
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}
export class BooleanSelect extends Select {
  list=[
    {
      name: '是',
      wid: 1,
    },
    {
      name: '否',
      wid: 0,
    },
  ]
  constructor (options) {
    super()
    this.mergeOptions(options)
  }
}

// 毕业中学
export class GraduationSchool extends Base {
  component = BSelectGraduationSchool
  constructor (option) {
    super()
    this.mergeOptions(option)
  }
}
